import { Component, OnInit } from '@angular/core';
import { BaseApi } from 'src/backend/api/base-api';

@Component({
  selector: 'app-landingtopblue',
  templateUrl: './landingtopblue.component.html',
  styleUrls: ['./landingtopblue.component.scss']
})
export class LandingtopblueComponent implements OnInit {
  userDetail: any;
  constructor(
    private baseApi: BaseApi
  ) { }

  ngOnInit(): void {
    this.userDetail = this.baseApi.getUserSession();
  }

}
